/* INNOR — page d'accueil : carrousel des pièces (chapitre blanc).

   Le défilement lui-même n'est PAS écrit ici. La pellicule est un conteneur
   à défilement natif avec accrochage (scroll-snap) : le doigt la fait
   glisser sur mobile, la molette horizontale et le clavier fonctionnent,
   et rien n'a besoin d'être resynchronisé au redimensionnement ni après une
   rotation d'écran. Une implémentation en transform aurait dû recalculer
   toutes ces positions à la main, pour le même résultat visible.

   Ce fichier ne fait donc que trois choses :
     - pousser la pellicule d'une largeur de cadre quand on clique un chevron ;
     - dire quel cadre est à l'écran (compteur, barres) ;
     - boucler du dernier au premier, pour qu'aucun chevron ne soit jamais
       inerte — trois pièces, on doit pouvoir tourner en rond.

   L'observation se fait par IntersectionObserver et non par un écouteur de
   scroll : c'est le navigateur qui décide quand un cadre est « à l'écran »,
   sans faire tourner du code à chaque pixel de défilement — et la plaque
   est déjà pilotée au scroll par innor-scene.js, inutile d'en rajouter. */
(function () {
  'use strict';

  function deuxChiffres(n) {
    return n < 10 ? '0' + n : String(n);
  }

  function bind(root) {
    var track = root.querySelector('[data-carrousel-track]');
    if (!track) return;

    var frames = Array.prototype.slice.call(root.querySelectorAll('[data-carrousel-frame]'));
    if (!frames.length) return;

    var bars = Array.prototype.slice.call(root.querySelectorAll('[data-carrousel-goto]'));
    var current = root.querySelector('[data-carrousel-current]');
    var prev = root.querySelector('[data-carrousel-prev]');
    var next = root.querySelector('[data-carrousel-next]');
    var index = 0;

    var reduit = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var anim = null;

    /* GLISSEMENT ÉCRIT À LA MAIN, ET NON behavior: 'smooth'.

       Mesuré le 13 août : dans la page réelle — pellicule à accrochage
       obligatoire, posée sur une plaque collée que le récit met à l'échelle —
       `scrollTo({ behavior: 'smooth' })` ne déplaçait RIEN (scrollLeft restait
       à 0), alors que la même valeur assignée directement fonctionnait. Les
       chevrons paraissaient morts : le compteur avançait, l'image non.

       On anime donc scrollLeft nous-mêmes. L'accrochage est suspendu le temps
       du glissement : à `mandatory`, le navigateur ramène chaque valeur
       intermédiaire sur le point d'accrochage le plus proche et l'animation
       se fait avaler. Il est rétabli à l'arrivée, pour que le doigt retrouve
       son comportement natif. */
    function glisser(destination) {
      if (anim) cancelAnimationFrame(anim);
      if (reduit) { track.scrollLeft = destination; return; }

      var depart = track.scrollLeft;
      var ecart = destination - depart;
      if (Math.abs(ecart) < 1) return;

      var t0 = null;
      var duree = 520;
      track.style.scrollSnapType = 'none';

      function finir() {
        if (anim) { cancelAnimationFrame(anim); anim = null; }
        if (filet) { clearTimeout(filet); filet = null; }
        track.scrollLeft = destination;
        track.style.scrollSnapType = '';
      }

      /* Filet : si les images d'animation ne défilent pas (onglet en arrière-
         plan, économie d'énergie, moteur sans rAF), le cadre doit quand même
         changer. Mieux vaut un saut sec qu'un chevron sans effet. */
      var filet = setTimeout(finir, duree + 150);

      function pas(t) {
        if (t0 === null) t0 = t;
        var p = Math.min(1, (t - t0) / duree);
        var e = 1 - Math.pow(1 - p, 3);
        track.scrollLeft = depart + ecart * e;
        if (p < 1) anim = requestAnimationFrame(pas);
        else finir();
      }
      anim = requestAnimationFrame(pas);
    }

    function aller(i) {
      /* Modulo : le cadre suivant du dernier est le premier. Sans lui, un
         chevron sur deux devient inerte en bout de course, ce qui se lit
         comme une panne plutôt que comme une fin. */
      var cible = (i + frames.length) % frames.length;
      /* On marque AVANT de défiler : le compteur et les barres doivent
         répondre au clic, pas à la fin de l'animation. L'observateur reste
         la source de vérité pour le doigt, où personne n'a rien cliqué. */
      marquer(cible);
      glisser(frames[cible].offsetLeft - track.offsetLeft);
    }

    function marquer(i) {
      index = i;
      if (current) current.textContent = deuxChiffres(i + 1);
      bars.forEach(function (bar, n) {
        bar.classList.toggle('is-active', n === i);
        bar.setAttribute('aria-current', n === i ? 'true' : 'false');
      });
    }

    if (prev) prev.addEventListener('click', function () { aller(index - 1); });
    if (next) next.addEventListener('click', function () { aller(index + 1); });
    bars.forEach(function (bar) {
      bar.addEventListener('click', function () {
        aller(parseInt(bar.dataset.carrouselGoto, 10) || 0);
      });
    });

    /* Flèches du clavier quand la pellicule a le focus. Le conteneur défile
       déjà nativement avec les flèches, mais d'une poignée de pixels : on
       reprend la main pour que le geste change de PIÈCE, pas de position. */
    track.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight') { e.preventDefault(); aller(index + 1); }
      if (e.key === 'ArrowLeft') { e.preventDefault(); aller(index - 1); }
    });

    if ('IntersectionObserver' in window) {
      var observateur = new IntersectionObserver(function (entrees) {
        entrees.forEach(function (entree) {
          if (!entree.isIntersecting) return;
          var i = frames.indexOf(entree.target);
          if (i >= 0 && i !== index) marquer(i);
        });
      }, { root: track, threshold: 0.6 });
      frames.forEach(function (frame) { observateur.observe(frame); });
    }

    marquer(0);
  }

  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('[data-carrousel]').forEach(bind);
  });
})();
